import cn from 'classnames';
import { useId } from 'react';
import * as styles from './Inputs.module.scss';

type InputCheckbox = {
    label: string | React.ReactNode;  
    name: string;
    disabled?: boolean;
    readonly?: boolean;
    checked?: boolean;
    onChange?: (value: boolean) => void;
};

export const InputCheckbox = ({
    label,
    disabled,
    readonly,
    name,
    checked = false,
    onChange
}: InputCheckbox) => {
    const id = useId();
    return (
        <div className="form-checkbox">
            <input
                type="checkbox"
                id={id}
                name={name}
                readOnly={readonly}
                disabled={disabled}
                className={cn(disabled && styles.disabled)}
                checked={checked}
                onChange={ev => onChange?.(ev.target.checked)}
            />
            <label htmlFor={id}>
                {typeof label === 'string'
                    ? <span>{label}</span>
                    : label}
            </label>
        </div>
    )
};

export const InputRadio = ({
    label,
    disabled,
    readonly,
    name,
    checked = false,
    onChange
}: InputCheckbox) => {
    const id = useId();
    return <div className="form-radio">
        <input
            type="radio"
            name={name}
            id={id}
            readOnly={readonly}
            disabled={disabled}
            className={cn(disabled && styles.disabled)}
            checked={checked}
            onChange={ev => onChange?.(ev.target.checked)}
        />
        <label htmlFor={id}>
            {typeof label === 'string'
                ? <span>{label}</span>
                : label}
        </label>
    </div>
};